import SVG from '@/assets/svg/SVG';
import Button from '@/components/Button';
import { FiCheck, FiCopy } from '@/components/react-icons/main';
import Tag from '@/components/Tag';
import TextWithEllipsis from '@/components/TextWithEllipsis';
import clone from '@/lib/clone';
import copyToClipboard from '@/lib/copyToClipboard';
import stepActions from '@/screens/workflows/redux/actions/stepActions';
import { useState } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

const CardOutput = ({ onClick, output, children, active, index, isSelected, selectableIndex }) => {
  const [hasCopied, setHasCopied] = useState(false);
  const presentation = output?.__meta?.presentation || {};
  const fields = presentation?.fields || {};
  const entityUrl = presentation?.entityUrl;

  const handleIndexButtonClick = (e) => {
    e.stopPropagation();
    stepActions.set(`arguments.activeIndex`, index);
  };

  const handleCopyOutput = () => {
    const cleanOutput = clone(output);
    delete cleanOutput?.__meta;

    setHasCopied(true);
    copyToClipboard(JSON.stringify(cleanOutput, null, 2), { toast: true });

    setTimeout(() => {
      setHasCopied(false);
    }, 1000);
  };

  return (
    <div className={`card ${active ? 'active' : ''} ${isSelected ? 'selected' : ''} ${presentation?.className || ''}`}>
      <div className={'inner-card'} onClick={onClick}>
        {fields.image && (
          <div className={'image-wrapper'}>
            <SVG icon={fields.image} />
          </div>
        )}
        <div className={'main'}>
          <TextWithEllipsis className={'name'}>{fields.name}</TextWithEllipsis>
          {fields.description && typeof fields.description === 'string' && <div className={'description'}>{fields.description}</div>}
        </div>
        {!!output && <Button size={'xs'} className={'ghost medium'} title={'Copy object to clipboard'} icon={hasCopied ? FiCheck : FiCopy} onClick={handleCopyOutput} />}
        <div className={'tags'}>
          {fields.id && (
            <Tag className="id-tag">
              <span className={'label'}>ID</span>
              <span>{fields.id}</span>
            </Tag>
          )}
        </div>
        <div className="output-card-actions">
          {entityUrl && (
            <Button size={'xs'} className={'outline medium'} title={'View in external system'} route={entityUrl} icon={FiArrowUpRight} iconPosition="right">
              View
            </Button>
          )}
          {selectableIndex && (
            <Button size={'xs'} className={`filled loop-button ${isSelected ? 'active' : ''}`} onClick={handleIndexButtonClick} title={'Set as Active Loop'}>
              <span>i</span>
              {index + 1}
            </Button>
          )}
        </div>

        {!selectableIndex && !isNaN(index) && <div className={'output-number'}>{index + 1}</div>}
      </div>
      <div className={'children'}>{children}</div>{' '}
    </div>
  );
};

export default CardOutput;
